import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterQuestionsPipe } from './filterquestions.pipe';
import { FilterTopicsPipe } from './filtertopicdetails.pipe';



@NgModule( {
    declarations: [
        FilterQuestionsPipe,
        FilterTopicsPipe
    ],
    exports: [
        FilterQuestionsPipe,
        FilterTopicsPipe
    ],
    imports: [
        CommonModule
    ],
} )
export class PipesModule {
    
 }